<template>
    <ContentCard>
        <div class="text-center center-block browse">
            <b-form @submit="onSubmit" inline class="">
                <b-form-input
                    input="accountname"
                    v-model="browseAccountName"
                    placeholder="Enter account name"
                    required
                ></b-form-input>
                <b-button class="ml-1" type="submit" variant="primary">Show</b-button>
            </b-form>
        </div>
    </ContentCard>
</template>

<script>
    // @ is an alias to /src
    import ContentCard from "../components/ContentCard";

    export default {
        name: "browse",
        components: {
            ContentCard
        },
        data() {
            return {
                browseAccountName: null
            }
        },
        methods: {
            onSubmit() {
                this.$router.push({ path: "browse/" + this.browseAccountName });
            }
        }
    };
</script>
